import { ButtonBase } from '@mui/material';
import { NavLink } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';

import Logo from 'components/ui/Logo';
import config from 'config';

const useStyles = makeStyles()(() => ({
  logo: {
    maxWidth: '150px'
  }
}));

const LogoSection = () => {
  const { classes } = useStyles();

  return (
    <ButtonBase disableRipple component={NavLink} to={config.defaultPath}>
      <Logo className={classes.logo} />
    </ButtonBase>
  );
};

export default LogoSection;
